(function () {
  function setMessage(root, text, type) {
    var el = root.querySelector('[data-trade-in-message]');
    if (!el) return;
    el.textContent = text || '';
    el.classList.remove('is-error', 'is-success', 'is-info');
    if (type) el.classList.add('is-' + type);
  }

  async function saveCode(code, productId) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          recell_transaction_id: code,
          buy_with_exchange: 'yes',
          trade_in_product_id: productId || '',
        },
      }),
    });
  }

  function bind(root) {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var params = new URLSearchParams(window.location.search);
    var productHandle = params.get('product') || '';
    var productId = params.get('product_id') || '';
    if (productId) root.setAttribute('data-product-id', productId);
    if (productHandle) {
      root.setAttribute('data-return-url', '/products/' + encodeURIComponent(productHandle));
    }

    var input = root.querySelector('[data-trade-in-code]');
    var submit = root.querySelector('[data-trade-in-submit]');
    var closeBtn = root.querySelector('[data-trade-in-footer-close]');
    var footer = root.querySelector('[data-trade-in-footer]');
    var returnUrl = root.getAttribute('data-return-url') || '/cart';

    // Prefill code if returning with one already
    var existingCode = params.get('trade_in_code');
    if (existingCode && input) input.value = existingCode;

    if (closeBtn && footer) {
      closeBtn.addEventListener('click', function () {
        footer.hidden = true;
      });
    }

    if (submit) {
      submit.addEventListener('click', async function () {
        var code = (input && input.value ? input.value : '').trim();
        if (!code) {
          setMessage(root, 'Enter the code from your tested phone.', 'error');
          if (input) input.focus();
          return;
        }

        root.classList.add('is-loading');
        setMessage(root, 'Saving your trade-in code…', 'info');
        try {
          await saveCode(code, root.getAttribute('data-product-id') || '');
          setMessage(root, 'Code saved. Continue to your product to complete purchase.', 'success');
          var target = returnUrl;
          var separator = target.indexOf('?') >= 0 ? '&' : '?';
          window.setTimeout(function () {
            window.location.href = target + separator + 'trade_in_code=' + encodeURIComponent(code);
          }, 700);
        } catch (err) {
          setMessage(root, err.message || 'Could not save code. Try again.', 'error');
        } finally {
          root.classList.remove('is-loading');
        }
      });
    }

    if (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          if (submit) submit.click();
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-trade-in-page]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
